import React from 'react';
import './Scrollable.css';

const Scrollable = ({ children }) => {
  return (
    <div className="scrollable">
      {children}
    </div>
  );
};

export default Scrollable;
